import $ from 'jquery';

export default function prettyCheckable() {
  
  function init() {
    var inputList = $('.prettyCheckbox');
    for (var i = inputList.length - 1; i >= 0; i--) {
      $(inputList[i]).prettyCheckable();
    }
  }
  
  if($('.prettyCheckbox').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/assets/js/pretty-checkable.js